import React, { useState } from 'react';
import { X, Share, Plus } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from './ui/card';

/**
 * A component that shows instructions for adding the app to home screen on iOS
 */
const AddToHomeScreen = ({ onClose }) => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) {
    return null;
  }

  const handleDismiss = () => {
    setDismissed(true);
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="relative">
          <Button 
            variant="ghost" 
            size="icon" 
            className="absolute right-2 top-2" 
            onClick={handleDismiss}
          >
            <X className="h-4 w-4" />
          </Button>
          <CardTitle>Add to Home Screen</CardTitle>
        </CardHeader>
        
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            For the best experience, add this app to your home screen:
          </p>
          <ol className="space-y-3 list-decimal pl-5">
            <li className="text-sm">
              Tap the <strong>Share</strong> button <Share className="h-4 w-4 inline" /> at the bottom of Safari
            </li>
            <li className="text-sm">
              Scroll and tap <strong>Add to Home Screen</strong> <Plus className="h-4 w-4 inline" />
            </li>
            <li className="text-sm">
              Tap <strong>Add</strong> in the top right
            </li>
          </ol>
          <p className="text-sm text-muted-foreground">
            Once added, the app will run in full-screen mode without Safari controls!
          </p>
        </CardContent>
        
        <CardFooter className="flex justify-end">
          <Button onClick={handleDismiss}>
            Got it
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default AddToHomeScreen; 